import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fetchTokens } from "../api/tokens";

/**
 * Fetches tokens for the current UI language.
 * Re-fetches automatically when language changes.
 * @returns {{ tokens: {syntax:{},queries:{},actions:{}}|null, loading: boolean, error: string|null }}
 */
export function useTokens() {
  const { i18n } = useTranslation();
  const [tokens, setTokens]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchTokens(i18n.language)
      .then((data) => { if (!cancelled) setTokens(data); })
      .catch((err) => { if (!cancelled) setError(err.message); })
      .finally(()  => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [i18n.language]);

  return { tokens, loading, error };
}
